import * as Yup from "yup";
import {
  YYYYMMDD,
  POSTAL_CODE_PATTERN,
  PHONE_NUMBER_PATTERN,
} from "@eave/shared/utils/regex-patterns";

export const validationSchema = Yup.object().shape({
  name: Yup.string().min(2, "Too short!").required("Required"),
  ein: Yup.string()
    .length(9, "Too short - EINs are 9 digits")
    .max(9, "Too many characters")
    .nullable(),
  start_date: Yup.string()
    .matches(YYYYMMDD, "Please enter a valid start date.")
    .required("Required"),
  end_date: Yup.string().when("start_date", (start_date, schema) => {
    if (start_date === undefined || start_date === "") {
      // If the start_date wasn't yet entered, the end_date can be nullable!
      return schema.nullable();
    }

    // If the start_date exists, then require that the end_date is after the start_date
    return Yup.date().min(start_date, "The end date cannot be before the start date.").nullable();
  }),
  years_in_line_of_work: Yup.number()
    .min(0, "Too low. Must be a positive integer.")
    .max(99, "This value seems high - please check again.")
    .required("Required"),
  address_line1: Yup.string().min(2, "Too short.").max(30, "Too long!").required("Required"),
  address_line2: Yup.string().max(30, "Too long!"),
  city: Yup.string().min(2, "Too short.").max(30, "Too long!").required("Required"),
  state: Yup.string().min(2, "Too short.").max(30, "Too long!").required("Required"),
  postal_code: Yup.string()
    .matches(
      POSTAL_CODE_PATTERN,
      "Please enter a valid postal code in either the 5 or 9 digit format.",
    )
    .required("Required"),
  contact: Yup.string()
    .matches(PHONE_NUMBER_PATTERN, "Please enter a valid phone number.")
    .required("Required"),
  self_employed_ownership_percent: Yup.number()
    .min(1, "Please an integer value from 1-100")
    .max(100, "Please an integer value from 1-100")
    .nullable(),
});

export const initialValues = {
  id: "",
  name: "",
  ein: "",
  borrower_entity: "",

  start_date: "",
  end_date: null,
  employer_is_party_to_transaction: false,

  address_line1: "",
  address_line2: "",
  city: "",
  state: "",
  postal_code: "",

  contact: "",
  contact_extension: "",

  title: "",
  employment_type: "",
  is_seasonal_income: false,
  is_foreign_income: false,
  income_type: "",
  self_employed_ownership_percent: null,
  shows_on_tax_returns: null,
  years_in_line_of_work: null,
};
